import Header from "../parts/header";
import Leftbar from "../parts/leftbarCoaching";
import { MsbAgentModal } from "../parts/modals/MsbAgentModal";
import { useRillContext } from "../rill/RillReact/share/base";

function Page({ children }) {
  const { locals } = useRillContext();
  const { activeUser, query } = locals || {};
  return (
    <div id="athlete-wrapper">
      <label htmlFor="mobile-nav-toggle" />
      <Header athletePortalEnabled query={query} />
      <Leftbar query={query} />
      {children}
      <MsbAgentModal activeUser={activeUser} />
    </div>
  );
}

export default Page;
